import { render } from "./TeamTable.vue?vue&type=template&id=401e15e7"
import script from "./TeamTable.vue?vue&type=script&lang=js"
export * from "./TeamTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__